
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AcknowledgeProjectClientItemRequest,
  CompleteTimeAndMaterialProjectRequest,
  ProjectActivityResource,
  ProjectInformationResource,
  ProjectInvoiceListResource,
  ProjectManagerUpdateParam,
  ProjectRenewParam,
  ProjectValidationParam,
  PurchaseOrderParam,
  TermsAppendixParam,
  UpdateClockOffsetDateTimeRequest,
  ValidationError,
} from '../models';
import {
    AcknowledgeProjectClientItemRequestFromJSON,
    AcknowledgeProjectClientItemRequestToJSON,
    CompleteTimeAndMaterialProjectRequestFromJSON,
    CompleteTimeAndMaterialProjectRequestToJSON,
    ProjectActivityResourceFromJSON,
    ProjectActivityResourceToJSON,
    ProjectInformationResourceFromJSON,
    ProjectInformationResourceToJSON,
    ProjectInvoiceListResourceFromJSON,
    ProjectInvoiceListResourceToJSON,
    ProjectManagerUpdateParamFromJSON,
    ProjectManagerUpdateParamToJSON,
    ProjectRenewParamFromJSON,
    ProjectRenewParamToJSON,
    ProjectValidationParamFromJSON,
    ProjectValidationParamToJSON,
    PurchaseOrderParamFromJSON,
    PurchaseOrderParamToJSON,
    TermsAppendixParamFromJSON,
    TermsAppendixParamToJSON,
    UpdateClockOffsetDateTimeRequestFromJSON,
    UpdateClockOffsetDateTimeRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface AcceptContractAmendmentRequest {
    projectId: string;
    quoteId: string;
    comment?: string;
}

export interface AcknowledgeProjectClientItemOperationRequest {
    projectId: string;
    acknowledgeProjectClientItemRequest: AcknowledgeProjectClientItemRequest;
}

export interface CompleteTimeAndMaterialProjectOperationRequest {
    projectId: string;
    completeTimeAndMaterialProjectRequest: CompleteTimeAndMaterialProjectRequest;
}

export interface DeletePurchaseOrderRequest {
    projectId: string;
}

export interface GetProjectActivityRequest {
    projectId: string;
}

export interface GetProjectInformationRequest {
    projectId: string;
    lotId?: string;
}

export interface GetProjectInformationByCorrelationIdRequest {
    correlationId: string;
    lotId?: string;
}

export interface GetProjectInvoiceListRequest {
    projectId: string;
}

export interface PutTermsAppendixRequest {
    projectId: string;
    termsAppendixParam: TermsAppendixParam;
}

export interface RenewProjectRequest {
    projectId: string;
    projectRenewParam: ProjectRenewParam;
}

export interface SetPurchaseOrderToProjectRequest {
    projectId: string;
    purchaseOrderParam: PurchaseOrderParam;
}

export interface UpdateClockOffsetDateTimeOperationRequest {
    projectId: string;
    updateClockOffsetDateTimeRequest: UpdateClockOffsetDateTimeRequest;
}

export interface UpdateProjectManagerRequest {
    projectId: string;
    projectManagerUpdateParam: ProjectManagerUpdateParam;
}

export interface ValidateProjectRequest {
    projectId: string;
    projectValidationParam: ProjectValidationParam;
    lotId?: string;
}

/**
 * 
 */
export class ProjectClientApi extends runtime.BaseAPI {

    /**
     * Accept freelancer proposed amendment to the contract
          */
    async acceptContractAmendmentRaw(requestParameters: AcceptContractAmendmentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling acceptContractAmendment().'
            );
        }

        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling acceptContractAmendment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['comment'] != null) {
            queryParameters['comment'] = requestParameters['comment'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/amendment/{quoteId}/accept`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Accept freelancer proposed amendment to the contract
          */
    async acceptContractAmendment(requestParameters: AcceptContractAmendmentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptContractAmendmentRaw(requestParameters, initOverrides);
    }

    /**
     * Set a project client item as acknowledged
          */
    async acknowledgeProjectClientItemRaw(requestParameters: AcknowledgeProjectClientItemOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling acknowledgeProjectClientItem().'
            );
        }

        if (requestParameters['acknowledgeProjectClientItemRequest'] == null) {
            throw new runtime.RequiredError(
                'acknowledgeProjectClientItemRequest',
                'Required parameter "acknowledgeProjectClientItemRequest" was null or undefined when calling acknowledgeProjectClientItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/acknowledge`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AcknowledgeProjectClientItemRequestToJSON(requestParameters['acknowledgeProjectClientItemRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Set a project client item as acknowledged
          */
    async acknowledgeProjectClientItem(requestParameters: AcknowledgeProjectClientItemOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeProjectClientItemRaw(requestParameters, initOverrides);
    }

    /**
     * Client complete project, only for TimeAndMaterial
          */
    async completeTimeAndMaterialProjectRaw(requestParameters: CompleteTimeAndMaterialProjectOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling completeTimeAndMaterialProject().'
            );
        }

        if (requestParameters['completeTimeAndMaterialProjectRequest'] == null) {
            throw new runtime.RequiredError(
                'completeTimeAndMaterialProjectRequest',
                'Required parameter "completeTimeAndMaterialProjectRequest" was null or undefined when calling completeTimeAndMaterialProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/complete`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteTimeAndMaterialProjectRequestToJSON(requestParameters['completeTimeAndMaterialProjectRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Client complete project, only for TimeAndMaterial
          */
    async completeTimeAndMaterialProject(requestParameters: CompleteTimeAndMaterialProjectOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.completeTimeAndMaterialProjectRaw(requestParameters, initOverrides);
    }

    /**
     * Delete the Purchase Order
          */
    async deletePurchaseOrderRaw(requestParameters: DeletePurchaseOrderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deletePurchaseOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/purchase-order`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete the Purchase Order
          */
    async deletePurchaseOrder(requestParameters: DeletePurchaseOrderRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePurchaseOrderRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve current action to be done by the client and the history of past events
          */
    async getProjectActivityRaw(requestParameters: GetProjectActivityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectActivityResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectActivityResource>({
            path: `/project-client/api/project/{projectId}/activity`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectActivityResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve current action to be done by the client and the history of past events
          */
    async getProjectActivity(requestParameters: GetProjectActivityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectActivityResource> {
        const response = await this.getProjectActivityRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Fetch the project information
          */
    async getProjectInformationRaw(requestParameters: GetProjectInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectInformationResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectInformation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lotId'] != null) {
            queryParameters['lotId'] = requestParameters['lotId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectInformationResource>({
            path: `/project-client/api/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch the project information
          */
    async getProjectInformation(requestParameters: GetProjectInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectInformationResource> {
        const response = await this.getProjectInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Fetch the project information by correlation id
          */
    async getProjectInformationByCorrelationIdRaw(requestParameters: GetProjectInformationByCorrelationIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectInformationResource>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling getProjectInformationByCorrelationId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['correlationId'] != null) {
            queryParameters['correlationId'] = requestParameters['correlationId'];
        }

        if (requestParameters['lotId'] != null) {
            queryParameters['lotId'] = requestParameters['lotId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectInformationResource>({
            path: `/project-client/api/project`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch the project information by correlation id
          */
    async getProjectInformationByCorrelationId(requestParameters: GetProjectInformationByCorrelationIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectInformationResource> {
        const response = await this.getProjectInformationByCorrelationIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve current activity report, invoices, expenses
          */
    async getProjectInvoiceListRaw(requestParameters: GetProjectInvoiceListRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectInvoiceListResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectInvoiceList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectInvoiceListResource>({
            path: `/project-client/api/project/{projectId}/invoice`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectInvoiceListResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve current activity report, invoices, expenses
          */
    async getProjectInvoiceList(requestParameters: GetProjectInvoiceListRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectInvoiceListResource> {
        const response = await this.getProjectInvoiceListRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update the Client terms appendix
          */
    async putTermsAppendixRaw(requestParameters: PutTermsAppendixRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling putTermsAppendix().'
            );
        }

        if (requestParameters['termsAppendixParam'] == null) {
            throw new runtime.RequiredError(
                'termsAppendixParam',
                'Required parameter "termsAppendixParam" was null or undefined when calling putTermsAppendix().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/terms-appendix`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TermsAppendixParamToJSON(requestParameters['termsAppendixParam']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the Client terms appendix
          */
    async putTermsAppendix(requestParameters: PutTermsAppendixRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.putTermsAppendixRaw(requestParameters, initOverrides);
    }

    /**
     * Create a new project from an existing one
          */
    async renewProjectRaw(requestParameters: RenewProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling renewProject().'
            );
        }

        if (requestParameters['projectRenewParam'] == null) {
            throw new runtime.RequiredError(
                'projectRenewParam',
                'Required parameter "projectRenewParam" was null or undefined when calling renewProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/renew`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectRenewParamToJSON(requestParameters['projectRenewParam']),
        }, initOverrides);

        return response;
    }

    /**
     * Create a new project from an existing one
          */
    async renewProject(requestParameters: RenewProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.renewProjectRaw(requestParameters, initOverrides);
    }

    /**
     * Update the Purchase Order
          */
    async setPurchaseOrderToProjectRaw(requestParameters: SetPurchaseOrderToProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling setPurchaseOrderToProject().'
            );
        }

        if (requestParameters['purchaseOrderParam'] == null) {
            throw new runtime.RequiredError(
                'purchaseOrderParam',
                'Required parameter "purchaseOrderParam" was null or undefined when calling setPurchaseOrderToProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/purchase-order`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseOrderParamToJSON(requestParameters['purchaseOrderParam']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the Purchase Order
          */
    async setPurchaseOrderToProject(requestParameters: SetPurchaseOrderToProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.setPurchaseOrderToProjectRaw(requestParameters, initOverrides);
    }

    /**
     * Update the project Clock date time machine
          */
    async updateClockOffsetDateTimeRaw(requestParameters: UpdateClockOffsetDateTimeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateClockOffsetDateTime().'
            );
        }

        if (requestParameters['updateClockOffsetDateTimeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClockOffsetDateTimeRequest',
                'Required parameter "updateClockOffsetDateTimeRequest" was null or undefined when calling updateClockOffsetDateTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/clock`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClockOffsetDateTimeRequestToJSON(requestParameters['updateClockOffsetDateTimeRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the project Clock date time machine
          */
    async updateClockOffsetDateTime(requestParameters: UpdateClockOffsetDateTimeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateClockOffsetDateTimeRaw(requestParameters, initOverrides);
    }

    /**
     * Update the project manager
          */
    async updateProjectManagerRaw(requestParameters: UpdateProjectManagerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProjectManager().'
            );
        }

        if (requestParameters['projectManagerUpdateParam'] == null) {
            throw new runtime.RequiredError(
                'projectManagerUpdateParam',
                'Required parameter "projectManagerUpdateParam" was null or undefined when calling updateProjectManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/manager`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectManagerUpdateParamToJSON(requestParameters['projectManagerUpdateParam']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the project manager
          */
    async updateProjectManager(requestParameters: UpdateProjectManagerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProjectManagerRaw(requestParameters, initOverrides);
    }

    /**
     * Validate the project or the month of the project (recurring)
          */
    async validateProjectRaw(requestParameters: ValidateProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling validateProject().'
            );
        }

        if (requestParameters['projectValidationParam'] == null) {
            throw new runtime.RequiredError(
                'projectValidationParam',
                'Required parameter "projectValidationParam" was null or undefined when calling validateProject().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lotId'] != null) {
            queryParameters['lotId'] = requestParameters['lotId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/project/{projectId}/validate`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectValidationParamToJSON(requestParameters['projectValidationParam']),
        }, initOverrides);

        return response;
    }

    /**
     * Validate the project or the month of the project (recurring)
          */
    async validateProject(requestParameters: ValidateProjectRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.validateProjectRaw(requestParameters, initOverrides);
    }

}
